import { Box, Typography } from "@mui/material";
import { SearchBar } from "../SearchBar";
import { TableFilter, SessionFilterOption, StandardFilterOption, TableName, CombinedFilterOption } from "../TableFilter";
import { TableHeader } from "../TableHeader";
import { RenderToolbarProps } from "../TablePaginated/TablePaginated";
import { HeaderActionType } from "../../ManagePageComponents";

type Props<T extends SessionFilterOption | StandardFilterOption> = {
    title: string;
    subTitle?: string;
    newButtonLabel?: string;
    rerouteLabel?: string;
    filterTableName?: TableName;
    titleSize?: string;
    limitFilter?: boolean;
    headerActions?: HeaderActionType[]
    onNew?: () => void;
    onReroute?: () => void;
    onTriage?: () => void;
    onBack?: () => void;
    onFilter?: (option: T) => void;
    onBulkLaunch?: () => void;
};

export type TableToolbarStackedProps<T extends SessionFilterOption | StandardFilterOption> = Props<T> & RenderToolbarProps;

export default function TableToolbarStacked<T extends SessionFilterOption | StandardFilterOption>({
    title,
    subTitle,
    titleSize,
    newButtonLabel,
    rerouteLabel,
    searchQuery,
    headerActions,
    onBack,
    onSearch,
    onSearchClear,
    onFilter,
    filterTableName,
    limitFilter
}: TableToolbarStackedProps<T>) {
    return (
        <Box component="div" sx={{ backgroundColor: "#fff" }}>
            <TableHeader
                title={title}
                titleSize={titleSize}
                subtitle={subTitle}
                newLabelName={newButtonLabel}
                headerActions={headerActions}
                onBack={onBack}
            />
            <SearchBar
                value={searchQuery}
                onChange={onSearch}
                clearSearch={onSearchClear}
            >
                {(onFilter && filterTableName) && <TableFilter tableName={filterTableName} defaultValue="ALL" limitFilter={limitFilter}
                    onChange={(option) => {
                        onFilter?.(option as T)
                    }}
                />}
            </SearchBar>
        </Box>
    );
}
